import styled, { css } from 'styled-components';
import { breakpointUp } from '../../../styles/mediaUtils';
import { textSizes } from '../../../styles/typography';

export interface SharedProps {
  type: 'grid' | 'vertical';
  size: 'sm' | 'md' | 'lg';
}

export const StatFigure = styled.dt`
  ${textSizes.xl};
  color: ${({ theme }) => theme.textPrimary};
  padding-bottom: ${({ theme }) => theme.space4};
`;

export const StatDescription = styled.dd`
  ${textSizes.sm}
  margin: 0;
  color: ${({ theme }) => theme.textPrimary};
`;

export const StatSource = styled.div`
  color: ${({ theme }) => theme.text400};
  padding-top: ${({ theme }) => theme.space4};

  a,
  span {
    color: inherit !important;
  }
`;

export const StatsList = styled.dl<SharedProps>`
  ${({ type, size }) => css`
    margin: 0;
    display: grid;
    row-gap: 2rem;
    background-color: ${({ theme }) => theme.bgSecondary};
    padding: 1.5rem;

    @media ${breakpointUp.tablet} {
      padding: 2.5rem;
    }

    ${type === 'grid' &&
    css`
      grid-template-columns: 1fr 1fr;
      column-gap: 2rem;
      row-gap: 1.5rem;
      min-width: min(100%, 14.5rem);
    `};

    ${size === 'md' &&
    css`
      ${StatFigure} {
        ${textSizes.xxl}
      }

      ${type === 'grid' &&
      css`
        min-width: min(100%, 24rem);
      `}
    `};

    ${size === 'lg' &&
    css`
      ${StatFigure} {
        ${textSizes.xxxxl}
      }

      ${type === 'grid' &&
      css`
        min-width: max(100%, 24rem);
      `}
    `}
  `}
`;
